import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import template from './dockingPlaneButton.jsx';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';

var DockingPlaneButton = /*#__PURE__*/function (_React$Component) {
  _inherits(DockingPlaneButton, _React$Component);

  var _super = _createSuper(DockingPlaneButton);

  function DockingPlaneButton() {
    var _this;

    _classCallCheck(this, DockingPlaneButton);

    _this = _super.call(this);
    _this.hidePopoverTimeout = undefined;
    _this.state = {
      showPopover: false,
      hoverPopover: false
    };
    return _this;
  }

  _createClass(DockingPlaneButton, [{
    key: "showPopover",
    value: function showPopover() {
      var _this2 = this;

      if (!this.isDisabled()) {
        this.setState({
          showPopover: true
        });
        window.setTimeout(function () {
          _this2.setState({
            hoverPopover: true
          });
        });

        if (this.hidePopoverTimeout) {
          window.clearTimeout(this.hidePopoverTimeout);
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange(direction) {
      if (!this.isDisabled() && !this.props.disabledDirections.includes(direction)) {
        this.props.onChange(direction);
      }
    }
  }, {
    key: "hidePopover",
    value: function hidePopover() {
      var _this3 = this;

      this.setState({
        hoverPopover: false
      });
      this.hidePopoverTimeout = window.setTimeout(function () {
        _this3.setState({
          showPopover: false
        });

        _this3.hidePopoverTimeout = undefined;
      }, 200);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.props.disabled === true || this.isVerticalDisabled() && this.isHorizontalDisabled();
    }
  }, {
    key: "isVerticalDisabled",
    value: function isVerticalDisabled() {
      return this.props.disabledDirections.includes('VERTICAL');
    }
  }, {
    key: "isHorizontalDisabled",
    value: function isHorizontalDisabled() {
      return this.props.disabledDirections.includes('HORIZONTAL');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.hidePopoverTimeout) {
        window.clearTimeout(this.hidePopoverTimeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return DockingPlaneButton;
}(React.Component);

DockingPlaneButton.displayName = displayNames.DOCKING_PLANE_BUTTON;
DockingPlaneButton.propTypes = {
  onChange: PropTypes.func.isRequired,
  vertical: PropTypes.bool,
  horizontal: PropTypes.bool,
  hintVertical: PropTypes.string,
  hintHorizontal: PropTypes.string,
  disabled: PropTypes.string,
  disabledDirections: PropTypes.arrayOf(PropTypes.string)
};
DockingPlaneButton.defaultProps = {
  vertical: false,
  horizontal: false,
  hintVertical: 'Vertical',
  hintHorizontal: 'Horizontal',
  disabled: false,
  disabledDirections: []
};
export default compose(DockingPlaneButton);